// extracted by mini-css-extract-plugin
module.exports = {"bookingSuccess":"BookingSuccess_bookingSuccess__31yET"};